export class ApplicationExternalLinksConstants {
    static COMPONENT_NAME = "ExternalLinks";
    static ARCGIS_ITEM_CATEGORY = "Annotations";
}
